import { IAppState } from '../../../../../AppModulesWrapper';
import { createSelector } from 'reselect';
import { selectServices } from './selectServices';

export const selectServiceIds = createSelector(
  (state: IAppState) => selectServices(state),
  services => {
    return services.map(service => service.type);
  },
);
